<style lang="scss" scoped>
	@import "./css/common.css";
</style>

<template>
	<div id="app">
		<router-view />
	</div>
</template>
<script>
	export default {
		data() {
			return {

			}
		},
		// created() {
		// 	setInterval(()=>{
		// 		this.resizeFun();
		// 		var scale1 = localStorage.getItem('scale');
		// 		document.body.style.zoom = scale1;//放大缩小相应倍数
		// 	},200)
		
		// },
		// methods: {
		// 	resizeFun() {
		// 		var devicewidth = document.documentElement.clientWidth;//获取当前分辨率下的可是区域宽度
		// 		var scale = devicewidth / 1920; // 分母——设计稿的尺寸
		// 		document.body.style.zoom = scale;//放大缩小相应倍数
		// 		localStorage.setItem('scale',scale)
		// 	}
		// }
	}
</script>
<style scoped>
	#app {
		min-height: 100vh;
	}
</style>
